import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useDeleteDocumentType = () => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Error while deleting document type");

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (documentType) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.delete(
        `${tenantVal}/documenttypes/delete`,
        { data: documentType }
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Document type deleted successfully");
      queryClient.invalidateQueries({ queryKey: ["documentTypes"] });
    },
    onError: handleNetworkError,
  });
};
